import { ThumbnailsStream } from '@mi-front/ui';
import { useTimezone } from '../../../../../../core/hooks';
import { PreviewBrush } from '../../components/preview/PreviewBrush';
import { PreviewFocusMarkers } from '../../components/preview/PreviewFocusMarkers';
import { PreviewWrapper } from '../../components/preview/elements';
import { STREAM_SCREEN_CONFIG } from '../../config';
import { useStreamSegmentsRange } from '../../hooks/segments/useStreamSegmentsQuery';
import { useLoggerRangeThumbnails } from './hooks/useLoggerRangeThumbnails';

export const LoggerVideoPreview = () => {
  const { thumbnails, isLoading } = useLoggerRangeThumbnails();
  const range = useStreamSegmentsRange();

  return (
    <PreviewWrapper
      data-testid="logger-video-preview"
      data-range-from={range.from}
      data-range-to={range.to}
    >
      <ThumbnailsStream
        compressed
        tz={useTimezone()}
        height={STREAM_SCREEN_CONFIG.previewHeightExpanded}
        range={range}
        disableHtmlEvents
        renderSvg={() => <PreviewBrush />}
        renderHtml={() => <PreviewFocusMarkers />}
        thumbnails={thumbnails}
        thumbnailsLoading={isLoading}
      />
    </PreviewWrapper>
  );
};
